import type { Supply } from '@/site/lib/types'

interface Props {
  list: Supply[]
  /** "Get the supplies" link (the tutorial's first link). */
  shopUrl?: string
}

const quantity = (s: Supply) => [s.quantity, s.unit].filter((v) => v !== '' && v !== null && v !== undefined).join(' ').toLowerCase()

/** "What you'll need": the supply list in a stitched panel. */
export default function SupplyList({ list, shopUrl }: Props) {
  if (list.length === 0 && !shopUrl) return null

  return (
    <section aria-labelledby="supplies" className="rounded-3xl bg-qt-soft p-2">
      <div className="qt-stitch flex flex-col rounded-[18px] px-5 py-5">
        <h2 id="supplies" className="mb-2 text-xl font-extrabold">
          What you'll need
        </h2>
        {list.length > 0 && (
          <ul className="divide-y divide-qt-stitch/30">
            {list.map((s, i) => (
              <li key={s.id ?? i}>
                <a href={s.url} target="_blank" rel="noreferrer" className="flex justify-between gap-4 py-2.5 text-sm font-semibold hover:underline">
                  <span>{s.display_title || s.title}</span>
                  <span className="shrink-0 font-extrabold">{quantity(s)}</span>
                </a>
              </li>
            ))}
          </ul>
        )}
        {shopUrl && (
          <a
            href={shopUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-3 flex h-12 items-center justify-center rounded-xl bg-qt-primary text-[15px] font-bold text-white hover:bg-qt-primary-hover"
          >
            Get the supplies
          </a>
        )}
      </div>
    </section>
  )
}
